<div [formGroup]="form" style="width: 100%">
    <mat-form-field
        appearance="fill"
        class="example-full-width mask"
        *ngIf="property.renderType === RenderType.TextBox"
        style="width: 100%"
        [ngStyle]="{opacity: property.disabled ? '0.5' : '1'}"
        [matTooltip]="property.tooltip ?? ''"
    >
        <mat-label>{{ property.displayName }}</mat-label>
        <input
            *ngIf="
                property.renderType === RenderType.TextBox &&
                property.inputType === InputType.Text
            "
            autocomplete="off"
            [readonly]="property.disabled"
            [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName"
            (change)="textBoxUpdate($event)"
            type="text"
            matInput
            [errorStateMatcher]="matcher"
            [placeholder]="property.displayName"
            [matTooltip]="property.tooltip ?? ''"
        />

        <input
            *ngIf="
                property.renderType === RenderType.TextBox &&
                property.inputType === InputType.Number
            "
            autocomplete="off"
            [readonly]="property.disabled"
            [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName"
            (change)="textBoxUpdate($event)"
            type="number"
            matInput
            [errorStateMatcher]="matcher"
            [placeholder]="property.displayName"
            [matTooltip]="property.tooltip ?? ''"
        />

        <input
            *ngIf="
                property.renderType === RenderType.TextBox &&
                property.inputType === InputType.Password
            "
            autocomplete="off"
            [readonly]="property.disabled"
            [attr.disabled]="property.disabled ? '' : null"
            [formControlName]="property.propertyName"
            (change)="textBoxUpdate($event)"
            [type]="hide ? 'password' : 'text'"
            matInput
            [errorStateMatcher]="matcher"
            [placeholder]="property.displayName"
            [matTooltip]="property.tooltip ?? ''"
        />
        <button
            *ngIf="
                property.renderType === RenderType.TextBox &&
                property.inputType === InputType.Password
            "
            matIconButton
            matSuffix
            class="visibility-btn"
            (click)="onTrigger($event)"
            [attr.aria-pressed]="hide"
            [disabled]="property.disabled"
        >
            <svg
                *ngIf="!hide"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
            >
                <path
                    d="M480-320q75 0 127.5-52.5T660-500q0-75-52.5-127.5T480-680q-75 0-127.5 52.5T300-500q0 75 52.5 127.5T480-320Zm0-72q-45 0-76.5-31.5T372-500q0-45 31.5-76.5T480-608q45 0 76.5 31.5T588-500q0 45-31.5 76.5T480-392Zm0 192q-146 0-266-81.5T40-500q54-137 174-218.5T480-800q146 0 266 81.5T920-500q-54 137-174 218.5T480-200Zm0-300Zm0 220q113 0 207.5-59.5T832-500q-50-101-144.5-160.5T480-720q-113 0-207.5 59.5T128-500q50 101 144.5 160.5T480-280Z"
                />
            </svg>

            <svg
                *ngIf="hide"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
            >
                <path
                    d="m644-428-58-58q9-47-27-88t-93-32l-58-58q17-8 34.5-12t37.5-4q75 0 127.5 52.5T660-500q0 20-4 37.5T644-428Zm128 126-58-56q38-29 67.5-63.5T832-500q-50-101-143.5-160.5T480-720q-29 0-57 4t-55 12l-62-62q41-17 84-25.5t90-8.5q151 0 269 83.5T920-500q-23 59-60.5 109.5T772-302Zm20 246L624-222q-35 11-70.5 16.5T480-200q-151 0-269-83.5T40-500q21-53 53-98.5t73-81.5L56-792l56-56 736 736-56 56ZM222-624q-29 26-53 57t-41 67q50 101 143.5 160.5T480-280q20 0 39-2.5t39-5.5l-36-38q-11 3-21 4.5t-21 1.5q-75 0-127.5-52.5T300-500q0-11 1.5-21t4.5-21l-84-82Zm319 93Zm-151 75Z"
                />
            </svg>
        </button>

        <mat-error
            *ngIf="!isValid"
            style="margin-top: 14px; margin-left: -10px"
        >
            <span *ngIf="Error('required')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['required']
                    : ''
            }}</span>
            <span *ngIf="Error('pattern')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['pattern']
                    : ''
            }}</span>
            <span *ngIf="Error('max')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['max']
                    : ''
            }}</span>
            <span *ngIf="Error('maxlength')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['maxlength']
                    : ''
            }}</span>

            <span *ngIf="Error('min')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['min']
                    : ''
            }}</span>
            <span *ngIf="Error('minlength')">{{
                property.validationErrorMessages
                    ? property.validationErrorMessages['minlength']
                    : ''
            }}</span>
        </mat-error>
    </mat-form-field>

    <mat-form-field
        class="mask"
        *ngIf="property.renderType === RenderType.Dropdown"
        appearance="fill"
        style="width: 100%"
        [matTooltip]="property.tooltip ?? ''"
    >
        <mat-label>{{ property.displayName }}</mat-label>
        <mat-select
            matInput
            [value]="property.value"
            [disabled]="property.disabled"
            (selectionChange)="dropdownUpdate($event)"
        >
            <mat-option
                *ngFor="let k of property.renderTypeValues"
                [value]="k.value"
                [disabled]="k.disabled ?? false"
                [matTooltip]="k.tooltip ?? ''"
            >
                {{ k.text }}</mat-option
            >
        </mat-select>
    </mat-form-field>

    <div
        class="d-flex align-items-center"
        *ngIf="property.renderType === RenderType.Slider"
    >
        <mat-label
            style="
                display: block;
                font: 800 14px/20px Roboto;
                margin-bottom: 10px;
            "
        >
            {{ property.displayName }}
        </mat-label>

        <div class="info-wrapper wrapper-title">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                class="info-icon"
                *ngIf="property.sliderTitleInfo"
                (click)="toggleInfo()"
            >
                <path
                    d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                />
            </svg>

            <div
                class="info-content info-bottom"
                *ngIf="property.sliderTitleInfo && info_visible"
            >
                {{ property.sliderTitleInfo }}
            </div>
        </div>
    </div>
    <ngx-slider
        style="width: 80%"
        *ngIf="property.renderType === RenderType.Slider"
        style="margin-top: 15px"
        [(value)]="property.value"
        [options]="options"
    ></ngx-slider>

    <div
        class="d-flex align-items-center"
        *ngIf="property.renderType === RenderType.CustomSlider"
    >
        <mat-label
            style="
                display: block;
                font: 800 14px/20px Roboto;
                margin-bottom: 10px;
            "
        >
            {{ property.displayName }}
        </mat-label>

        <div class="info-wrapper wrapper-title">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                class="info-icon"
                *ngIf="property.sliderTitleInfo"
                (click)="toggleInfo()"
            >
                <path
                    d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                />
            </svg>

            <div
                class="info-content info-bottom"
                *ngIf="property.sliderTitleInfo && info_visible"
            >
                {{ property.sliderTitleInfo }}
            </div>
        </div>
    </div>
    <div
        #customSliderRef
        *ngIf="property.renderType === RenderType.CustomSlider"
        class="custom-slider-wrapper"
    >
        <div
            class="slider-inside"
            (mousedown)="onSliderClick($event)"
            (click)="updateCustomSlider($event)"
        >
            <!-- * Slider background steps -->
            <!-- - First bar(placeholder) -->
            <!-- <span class="slider-bar bar-first"></span> -->

            <!-- - Center bar(steps) -->
            <span
                *ngFor="let step of steps; trackBy: trackByIndex"
                class="slider-bar"
                [class.disabled]="
                    property.disabled ||
                    step.legend > customSliderOption.maxSelectable
                "
            ></span>

            <!-- - Last bar(placeholder) -->
            <!-- <span
                class="slider-bar bar-last"
                [class.disabled]="
                    lastStep.legend > customSliderOption.maxSelectable
                "
            ></span> -->

            <!-- * Slider label -->
            <!-- - First label -->
            <span
                class="slider-legend slider-legend-first"
                [class.disabled]="customSliderDisabled"
            >
                {{ customSliderOption.customSteps[0].legend }}
            </span>

            <span
                #sliderLegendRef
                class="slider-legend"
                [style.left.px]="leftPosition"
            >
                {{
                    selectedCustomSliderValue.legend === 0 ||
                    selectedCustomSliderValue.legend === lastStep.legend
                        ? ''
                        : selectedCustomSliderValue.legend
                }}
            </span>

            <!-- - Last label -->
            <span
                class="slider-legend slider-legend-last"
                [class.disabled]="
                    customSliderDisabled ||
                    lastStep.legend > customSliderOption.maxSelectable
                "
            >
                {{ lastStep.legend }}
            </span>

            <!-- * Slider Thumb -->
            <div
                class="slider-thumb"
                [class.disabled]="property.disabled"
                [style.left.px]="leftPosition"
            ></div>
        </div>
    </div>

    <mat-checkbox
        *ngIf="property.renderType === RenderType.Checkbox"
        matInput
        color="primary"
        [formControlName]="property.propertyName"
        (change)="checkBoxUpdate($event)"
        [value]="property.value"
    >
        <mat-label>{{ property.displayName }}</mat-label>
    </mat-checkbox>

    <div
        class="d-flex align-items-center"
        *ngIf="
            property.renderType === RenderType.Toggle &&
            property.inputType == InputType.Boolean
        "
    >
        <mat-slide-toggle
            style="padding: 5px; margin-top: 10px"
            [checked]="property.value"
            [disabled]="property.disabled"
            matInput
            (change)="toggleUpdate($event)"
            [matTooltip]="property.tooltip ?? ''"
        >
            {{ property.displayName }}
        </mat-slide-toggle>

        <div class="info-wrapper">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                class="info-icon"
                *ngIf="property.tooltip"
                (click)="toggleInfo()"
            >
                <path
                    d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                />
            </svg>

            <div
                class="info-content info-top"
                *ngIf="property.tooltip && info_visible"
            >
                {{ property.tooltip }}
            </div>
        </div>
    </div>

    <div
        class="d-flex align-items-center"
        *ngIf="
            property.renderType === RenderType.Toggle &&
            property.inputType == InputType.Number
        "
    >
        <mat-slide-toggle
            style="padding: 5px; margin-top: 10px"
            [checked]="property.value == 1"
            [disabled]="property.disabled"
            matInput
            (change)="toggleUpdate($event)"
            [matTooltip]="property.tooltip ?? ''"
        >
            {{ property.displayName }}
        </mat-slide-toggle>

        <div class="info-wrapper">
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 -960 960 960"
                class="info-icon"
                *ngIf="property.tooltip"
                (click)="toggleInfo()"
            >
                <path
                    d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
                />
            </svg>

            <div
                class="info-content {{
                    property.tooltipPosition ?? 'info-top'
                }}"
                *ngIf="property.tooltip && info_visible"
            >
                {{ property.tooltip }}
            </div>
        </div>
    </div>
</div>
